module.exports = __webpack_public_path__ + "img/islamic.f93883ac.png";